import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

export const useAddOperationGate = (
  vesselImo: string | undefined,
  vesselCallId: string | undefined,
) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.addOperationGate(vesselCallId ?? ""),
    queryFn: () => drybulkCargoOperationsService.getAddOperationGate(vesselImo!, vesselCallId!),
    enabled: Boolean(vesselImo && vesselCallId),
    refetchOnWindowFocus: false,
    retry: false,
  });
